export interface ProgramCardProps {
    program: Program;
}

export interface Program {
    id: number;
    professionId: number;
    professionName: string;
    name: string;
    institutionName: string;
    institutionWebsite: string;
    degreeDiploma: boolean;
    degreeCertificate: boolean;
    degreeAssociate: boolean;
    degreeBaccalaureate: boolean;
    degreeMasters: boolean;
    distance: boolean;
    accreditedOn: Date | string;
    statusId: number;
    statusEffectiveDate: string;
    programWebsite: string;
    outcomesUrl: string;
    futureVoluntaryWithdraw: boolean;
    programDirector: Person;
    awardLetter: Document;
    satellites: Satellite[];
    concentrationTitle: string;
    levelTitle: string;
    addOnTracks: AddOnTrak[];
    show: boolean;
    programName?: string | null;
    programAddressId?: number | null;
    programAddress: ProgramAddress;
}

interface ProgramAddress {
        id: number;
        city?: string | null;
        state?: string | null;
        address?: string | null;
        address2?: string | null;
        address3?: string | null;
        address4?: string | null;
        zip?: string | null;
        country?: string | null;
        phone?: string | null;
        extension?: string | null;
        fax?: string | null;
        lng: number;
        lat: number;
}

interface AddOnTrak {
    addOnTrackId: number;
    title: string;
}

interface Person {
    peopleId: number;
    firstName: string;
    lastName: string;
    credentials: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    phone: string;
    extension: string;
    title: string;
    email: string;
    active: boolean;
    lng: number;
    lat: number;
}

interface Document {
    documentId: number;
    programId: number;
    blobFolderProgramId: number;
    title: string;
    fileUrl: string;
    fileDownloadName: string;
}

interface Satellite {
    satelliteId: number;
    programId: number;
    title: string;
    city: string;
    state: string;
}

export enum ProgramStatus {
    "Continuing" = 2,
    "Initial" = 3,
    "Probation" = 4,
    "Transfer" = 6,
    "Withdraw" = 7,
    "Expired" = 8,
    "Voluntarily Withdrawn" = 9,
    "Inactive" = 10,
    "Letter of Review" = 11,
    "Not Applicable" = 12,
    "Withhold" = 13,
    "Transfer of Sponsorship Initial" = 15,
    "Transfer of Sponsorship Continuing" = 16,
    "Transfer of Sponsorship Probation" = 17,
}

export enum SortStatuses {
    "Accredited" = 1,
    "Initial" = 2,
    "Withdrawn" = 3,
    "Distance" = 4,
    "Review" = 5,
}
